import { z } from 'zod';
import { EstoqueMovimentacaoResumoSchema } from './ProdutoEstoque';

export const ProdutoLoteEstoqueSchema = z.object({
    estoque: EstoqueMovimentacaoResumoSchema,
    ple_data_insercao: z.string(),
    ple_empresa_idpk: z.number().int(),
    ple_estoque_atual: z.number(),
    ple_estoque_disponivel: z.number(),
    ple_estoque_idpk: z.number().int(),
    ple_estoque_reservado: z.number(),
    ple_idpk: z.number().int(),
    ple_localizacao: z.string().nullable(),
    ple_produto_lote_idpk: z.string(),
    ple_ultima_alteracao: z.string().nullable(),
    ple_ultima_entrada: z.string().nullable(),
    ple_ultima_saida: z.string().nullable(),
});

export type ProdutoLoteEstoque = z.infer<typeof ProdutoLoteEstoqueSchema>;
